export default __webpack_public_path__ + "static/media/REACT.9a64d8d8.jpg";